import React from 'react'


export default function Contact() {
  return <>
    <footer id="contact" className='py-3 contact-section'>

    <div className="container-fluid py-5 mt-5 ">
            <div className="row px-5  ">
                <div className="col-md-6">
                    <h4>Contact Us</h4>
                    <p className='text-muted' >Via Discord : minority3356</p>
                </div>
                <div className='col-md-6'>
                  <h4>Social Partners</h4>
                  <li className='py-2'><a className='text-muted' href='https://www.elitepvpers.com/forum/silkroad-online-trading/5187858-bypass-hwid-ip-limit-through-vps-luminarycloud.html'>Elitepvpers</a></li>
                  <li className='py-2'><a className='text-muted' href='https://srocave.com/konular/ip-hwid-bypass-through-vps-luminarycloud.791/'>Sro Cave</a></li>
                  <li className='py-2'><a className='text-muted' href=''>Joymax</a></li>
                </div>

                <div className="col-md-12 py-2 mb-2">
                    <h5>Payment Partners  <i class="fab fa-btc"></i> <i class="fa-brands fa-cc-mastercard px-1"></i> <i class="fa-brands  px-1 fa-paypal"></i> <i class="fa-brands fa-cc-stripe"></i> </h5>
                </div>


                <hr className='text-muted'></hr>

                <div className="row py-3 text-center">
                    <div className="col-md-12">
                        <p>Copyrights <i class="fa-regular fa-copyright"></i>, Reserverd For LuminaryCloud Owner.</p>
                    </div>
                </div>

            </div>
        </div>

    </footer >

  </>
}
